import React from "react";
import "../assets/css/theme.min.css";

export default function LightTheme({ children }) {
  return <>{children}</>;
}
